import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { ISelect } from 'app/shared/models/select.model';
import { IDtoSystem } from 'app/shared/models/security/dto-system.model';
import { IDtoModule } from 'app/shared/models/security/dto-module.model';
import { DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
    selector: 'app-modal-system-module',
    templateUrl: './modal-system-module.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalSystemModuleComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formSystemModule: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Notificaciones */
    private configToast: any;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    /**Variables */
    private system: IDtoSystem;
    private module: IDtoModule;
    private action = 'add';
    /**Catalogos */
    private catalogRoles: Observable<ISelect[]>;
    /**Listas */
    private modules = new Array() as IDtoModule[];
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tableModules: DatatableComponent;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private identityService: IdentityService
        , private configGeneral: AppConfig) {
        this.initializeFormUserRole();
        this.configToast = this.configGeneral.getConfigToast();
    }
    ngOnInit(): void {
        this.onClose = new Subject();
        this.catalogRoles = this.identityService.getCatalogRoles();
        this.getModulesBySystem();
    }
    private initializeFormUserRole() {
        this.formSystemModule = this.formBuilder.group({
            name: [null, [Validators.required, Validators.maxLength(100)]],
            rolesId: [null, [Validators.required]]
        });
    }
    private submit(): void {
        if (this.formSystemModule.valid) {
            if (this.action === 'add') {
                this.save();
            } else {
                this.update();
            }
        } else {
            this.snotifyService.error('Capture toda la información requerida para poder continuar'
                , 'Validación', this.configToast);
        }
    }
    private save(): void {
        const data = this.formSystemModule.value as IDtoModule;
        data.systemId = this.system.systemLibraryId;
        this.identityService.addModule(data)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.resetForm();
                        this.getModulesBySystem();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private update(): void {
        const data = this.formSystemModule.value;
        this.module.name = data.name;
        this.module.rolesId = data.rolesId;
        this.identityService.updateModule(this.module)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.resetForm();
                        this.getModulesBySystem();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private getModulesBySystem(): void {
        this.identityService.getModulesBySystem(this.system.systemLibraryId)
            .subscribe(
                (x) => {
                    this.modules = x.data as IDtoModule[];
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private editModule(item: IDtoModule): void {
        this.module = item;
        this.formSystemModule.patchValue(this.module);
        this.action = 'edit';
    }
    private resetForm(): void {
        this.formSystemModule.reset();
        this.action = 'add';
    }
}
